import { AuthService } from './../../core/services/auth.service';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-logged-layout',
  templateUrl: './logged-layout.component.html',
  styleUrls: ['./logged-layout.component.scss']
})
export class LoggedLayoutComponent implements OnInit, OnDestroy {
  showFooter: boolean = true;
  hideSidebarIcon: boolean = false;
  navigationSubscription: Subscription;
  constructor(
    private router: Router,
    private _authService: AuthService,
    private spinner: NgxSpinnerService) {
  }

  ngOnInit() {
    this.navigationSubscription = this.router.events.subscribe((e: any) => {
      // If it is a NavigationEnd event re-initalise the component
      if (e instanceof NavigationEnd) {
        if (e.url && (e.url.includes('/search-page') || e.url.includes('/chats'))) {
          this.hideSidebarIcon = true;
        } else {
          this.hideSidebarIcon = false;
        }
      }
    });
    if (this.router.url === '/chats') {
      this.hideSidebarIcon = true;
    }

    if (this.router.url && this.router.url.includes('/search-page')) {
      this.hideSidebarIcon = true;
    }
  }
  getPermissions() {
    this.spinner.show();
    this._authService.getUserPermissions().subscribe(
      (result: any) => {
        this.spinner.hide();
      }, (error: any) => {
        this.spinner.hide();
      });
  }
  ngOnDestroy() {
    this.navigationSubscription.unsubscribe();
  }

}
